// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ResultsList  = lazy(() => import('../../views/results/list'))
const Results = [
  {
    
    path: '/results/list',
    element: <ResultsList/>
  }
]

export default Results